export default {"src":"/_next/static/media/flag.52604423.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};